export const SDK_VERSION = '8.0.0';
